<template>
  <div>
    <label>Required mappings</label>
    <ListEditor
      :addAttribute="()=>{}"
      :component="$options.RequiredAttributeField"
      :handleChangeListItem="()=>{}"
      :handleRemoveListItem="()=>{}"
      headerText=""
      :listItems="attributesConfig.requiredAttributes"
      :showHeader="false"
    />
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapActions, mapState } from 'vuex';
import ListEditor from 'client/components/FormValidation/ListEditor.vue';
import RequiredAttributeField from 'client/applications/scim/customConnector/RequiredAttributeField.vue';

const { application } = ItemTypeConsts;
const applicationModel = StoreModelMap[application];

export default {
  name: 'RequiredAttributesMapping',

  RequiredAttributeField,

  inject: ['$validator'],

  components: {
    ListEditor,
  },

  computed: {
    ...mapState(applicationModel, { attributes: 'customIdmMappingAttributes' }),

    attributesConfig() {
      return {
        requiredAttributes: [
          {
            required: true,
            attributeValue: {
              name: 'Company email',
              value: this.attributes.companyEmail,
              attribute: 'company email',
              changeHandler: this.handleEmailValueChange,
            },
            attribute: {
              name: 'company email attribute',
              value: 'Company Email',
              attribute: 'company email attribute',
            },
          },
          {
            required: true,
            attributeValue: {
              name: 'Username',
              value: this.attributes.username,
              attribute: 'username value',
              changeHandler: this.handleUsernameValueChange,
            },
            attribute: {
              name: 'username attribute',
              value: 'Username',
              attribute: 'username attribute',
            },
          },
        ],
      };
    },
  },

  methods: {
    ...mapActions(applicationModel, ['setCustomIdmAttributes']),

    handleEmailValueChange(value) {
      this.setCustomIdmAttributes({ companyEmail: value });
    },

    handleUsernameValueChange(value) {
      this.setCustomIdmAttributes({ username: value });
    },
  },
};
</script>
